import { useTranslation } from '@shared/localization';

import {
  Paragraph,
  PaymentIcon,
  PlusIcon,
  SimpleButton,
} from '@/components/common';
import { PaymentIntentFlow } from '@/schemas/PaymentIntent';
import NavigationService, {
  InternalPage,
} from '@/services/navigation/NavigationService';
import { InstrumentIconForModuleId } from '@/services/payments/instruments/PaymentInstrumentTypes';
import PaymentStore from '@/services/payments/PaymentStore';
import { getQaTestingProps, QaTestingElements } from '@/utils/qaTesting';

const styles = {
  container:
    'px-[32px] py-[20px] relative mt-xs first:mt-0 flex items-center ring-[1px] ring-silver-700 rounded-field bg-white justify-between',
  button: 'flex flex-row items-center text-gray space-x-3.5',
  iconsContainer:
    'ml-xs max-w-1/2 text-right space-x-sm flex flex-row flex-wrap justify-end gap-x-2 gap-y-1 max-w-[120px]',
  icons: '!m-0 max-w-[32px]',
};

interface INewInstrumentButtonProps {
  readonly flow: PaymentIntentFlow;
}

export function NewInstrumentButton({ flow }: INewInstrumentButtonProps) {
  const { t } = useTranslation();
  const supportedMethods = Array.from(
    new Set(
      PaymentStore.allowedPaymentModules.map(
        (moduleId) => InstrumentIconForModuleId[moduleId],
      ),
    ),
  );
  return (
    <div className="w-full mt-xs">
      <SimpleButton
        className="w-full"
        onClick={() =>
          NavigationService.navigateTo({ page: InternalPage.PaymentMethods })
        }
        {...getQaTestingProps(QaTestingElements.ContinueButton)}
      >
        <div className={styles.container}>
          <span className={styles.button}>
            <PlusIcon extraClassName="w-14 h-auto aspect-video self-center border rounded border-silver-700" />
            <Paragraph extraClassName="text-left">
              {flow === PaymentIntentFlow.Manage
                ? t('Add new payment method')
                : t('More ways to pay')}
            </Paragraph>
          </span>
          <div className={styles.iconsContainer}>
            {supportedMethods.map((moduleIcon) => (
              <PaymentIcon
                key={moduleIcon}
                icon={moduleIcon}
                extraClassName={styles.icons}
              />
            ))}
          </div>
        </div>
      </SimpleButton>
    </div>
  );
}
